import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.5488 12.2795V8.67697H9.44733V12.2795C9.44733 12.6758 9.77341 13 10.172 13H12.3459C12.7444 13 13.0705 12.6758 13.0705 12.2795V7.23596H14.3024C14.6357 7.23596 14.7951 6.82528 14.5415 6.60913L8.48357 1.18373C8.20821 0.938757 7.78792 0.938757 7.51256 1.18373L1.45464 6.60913C1.20826 6.82528 1.36044 7.23596 1.69377 7.23596H2.92564V12.2795C2.92564 12.6758 3.25173 13 3.65027 13H5.82417C6.22272 13 6.5488 12.6758 6.5488 12.2795Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Icon;
